import type { SearchFilters } from '../domain/SearchFilters';

import { emptyPanelFilters } from './emptyPanelFilters';

/**
 * Empty search filters state with default values
 */
export const emptySearchFilters: SearchFilters = {
  userId: undefined,
  subjectId: undefined,
  panelFilters: emptyPanelFilters,
};
